<template>
    <div class="cross-button"
        ref="button"
        @click="onClick">
        <i class="s-icon-cross" />
    </div>
</template>

<script>
export default {
  props: {
  },
  data() {
      return {
          scale: 1
      }
  },
  computed: {
      mainStyle() {
          return {
              transform: 'scale(' + this.scale + ')'
          }
      },
      button() {
          return this.$refs.button
      }
  },
  methods: {
    onClick(e) {
        this.$emit('click', e)
    },
    onOver() {
        this.scale = 1 + (20 / this.button.offsetWidth) / Math.max(300 / this.button.offsetWidth, 1)
    },
    onOut() {
        this.scale = 1
    }
  }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.cross-button
    position relative
    display flex
    align-items center
    justify-content center
    height 24px
    width 24px
    font-size 6px !important
    font-weight normal
    border-radius 100%
    color white
    background-color $color-red-1
    basic-button-v2(1.0, 0.5, "", 1.25)

    i
        font-size 8px !important

</style>



// WEBPACK FOOTER //
// src/components/v3/buttons/CrossButton.vue